import { Api } from '../api';
import { messages } from '../endpoints';
import type {
  DownloadAttachmentRequest,
  DownloadResponse,
  MessageEntity,
  MessageItemsResponse,
  MessageThreadsResponse,
  PostMessageResponse,
} from './models';

export class MessagesApi extends Api {
  static getThreads = (signal?: AbortSignal): Promise<MessageThreadsResponse> =>
    this.get<MessageThreadsResponse>({ url: messages.getThreads(), signal });

  static getThread = (threadId: string, signal?: AbortSignal): Promise<MessageItemsResponse> =>
    this.get({ url: messages.getThread(threadId), signal });

  static sendMessage = async (request: MessageEntity, signal?: AbortSignal) => {
    const { attachments, ...data } = request;

    const result = await this.post<MessageEntity, PostMessageResponse>({ url: messages.postMessage(), data, signal });

    if (attachments?.length) {
      const formData = new FormData();
      attachments.forEach((item) => formData.append('file', item));

      return this.post({ url: messages.postAttachment(result.data.messageId), data: formData, signal });
    }

    return result;
  };

  static deleteMessageGroup = (groupId: string, signal?: AbortSignal) => this.delete({ url: messages.deleteMessage(groupId), signal });

  static markGroupRead = (groupId: string, signal?: AbortSignal) => this.put({ url: messages.readMessage(), data: { groupId }, signal });

  static downloadAttachment = async (request: DownloadAttachmentRequest, signal?: AbortSignal): Promise<DownloadResponse> => {
    const response = await this.get<DownloadResponse>({ url: messages.downloadAttachment(request.messageId, request.fileId), signal });

    const filename = ((response.filename || '').split(';').find((n: string) => n.includes('filename=')) || '')
      .replace('filename=', '')
      .replace(/"/gim, '')
      .trim();

    return {
      filename,
      data: response.data,
    };
  };
}
